import(/* webpackMode: "eager", webpackExports: ["App"] */ "/opt/render/project/src/src/components/App.tsx");
